import React from 'react';

import SvgContainer from '../SvgContainer';

const Clock = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100960)">
                <path d="M7.992 0C3.576 0 0 3.584 0 8C0 12.416 3.576 16 7.992 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 7.992 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z" />
                <path d="M8.39995 4.6C8.39995 4.26863 8.13132 4 7.79995 4C7.46858 4 7.19995 4.26863 7.19995 4.6V6.36066V8.15032C7.19995 8.50417 7.38696 8.83168 7.6917 9.01152L10.9215 10.9176C11.1874 11.0746 11.53 10.9902 11.6927 10.7278C11.861 10.4562 11.7723 10.0992 11.4963 9.93819L8.39995 8.13115V4.6Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100960">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Clock;
